import React from 'react';
import { Grid } from '@mui/material';
import ConditionsEditor from './ConditionsEditor';

/**
 * Unified conditions section for action components
 */
const ActionConditionsSection = ({
  conditions,
  onConditionsChange,
  tags,
  dataSources,
  enabled = true,
  flushHorizontalPadding = false
}) => {
  if (!enabled) return null;

  return (
    <Grid
      item
      xs={12}
      sx={flushHorizontalPadding ? { pl: '0 !important' } : undefined}
    >
      <ConditionsEditor
        useConditions={true}
        onUseConditionsChange={() => {}} // Always enabled, so no-op
        conditions={conditions}
        onConditionsChange={onConditionsChange}
        conditionLogic={conditions?.conditionLogic || 'AND'}
        onConditionLogicChange={(conditionLogic) => onConditionsChange({ conditions, conditionLogic })}
        tags={tags}
        dataSources={dataSources}
      />
    </Grid>
  );
};

export default ActionConditionsSection;
